import AccountingProvidersListItem from './AccountingProvidersListItem';

export default AccountingProvidersListItem;
